import { CALL_API } from '../store/api';

export const UPDATE_OFFICE_FILTERS = 'UPDATE_OFFICE_FILTERS';
export const CLEAR_OFFICE_FILTERS = 'CLEAR_OFFICE_FILTERS';
export const UPDATE_AGENT_FILTERS = 'UPDATE_AGENT_FILTERS';
export const CLEAR_AGENT_FILTERS = 'CLEAR_AGENT_FILTERS';

export const OFFICE_REQUEST = 'OFFICE_REQUEST';
export const OFFICE_SUCCESS = 'OFFICE_SUCCESS';
export const OFFICE_FAILURE = 'OFFICE_FAILURE';
export const AGENT_REQUEST = 'AGENT_REQUEST';
export const AGENT_SUCCESS = 'AGENT_SUCCESS';
export const AGENT_FAILURE = 'AGENT_FAILURE';


export const updateOfficeFilters = (params) => (dispatch, getState) => {
    return dispatch({type: UPDATE_OFFICE_FILTERS, params: params });
}

export const clearOfficeFilters = () => (dispatch, getState) => {
    return dispatch({type: CLEAR_OFFICE_FILTERS });
}

export const updateAgentFilters = (params) => (dispatch, getState) => {
    return dispatch({type: UPDATE_AGENT_FILTERS, params: params });
}

export const clearAgentFilters = () => (dispatch, getState) => {
    return dispatch({type: CLEAR_AGENT_FILTERS });
}

export const fetchOffices = (body) => ({
    [CALL_API]: {
        types: [OFFICE_REQUEST, OFFICE_SUCCESS, OFFICE_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/getcompanies'
    }
});

export const fetchAgents = (body) => ({
    [CALL_API]: {
        types: [AGENT_REQUEST, AGENT_SUCCESS, AGENT_FAILURE],
        method: 'POST',
        body: body,
        endpoint: 'listings/getagents'
    }
});